import React, { createContext, useContext, useState, useEffect } from 'react';

interface UnlockContextType {
  isUnlocked: boolean;
  unlock: (code: string) => boolean;
  lock: () => void;
}

const UnlockContext = createContext<UnlockContextType | undefined>(undefined);

const UNLOCK_CODE = '5512135';
const STORAGE_KEY = 'vx-unlock-status';

export const UnlockProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isUnlocked, setIsUnlocked] = useState(false);

  useEffect(() => {
    // 从 localStorage 读取解锁状态
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'unlocked') {
      setIsUnlocked(true);
    }
  }, []);

  const unlock = (code: string): boolean => {
    if (code === UNLOCK_CODE) {
      setIsUnlocked(true);
      localStorage.setItem(STORAGE_KEY, 'unlocked');
      return true;
    }
    return false;
  };

  const lock = () => {
    setIsUnlocked(false);
    localStorage.removeItem(STORAGE_KEY);
  };

  return (
    <UnlockContext.Provider value={{ isUnlocked, unlock, lock }}>
      {children}
    </UnlockContext.Provider>
  );
};

export const useUnlock = () => {
  const context = useContext(UnlockContext);
  if (!context) {
    throw new Error('useUnlock must be used within UnlockProvider');
  }
  return context;
};
